import {useParams, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import api from "../api";
import QuestionItem from "../Quiz/Fragments/QuestionItem";
import {Button, Spin, Typography, Card, Progress, Row, Col, Space, Empty} from "antd";
import {useDispatch} from "react-redux";
import {ArrowRightOutlined, UnorderedListOutlined} from '@ant-design/icons';
import {useTranslation} from "react-i18next";
import {Helmet} from "react-helmet-async";
import ChatPromoBanner from "../Fragments/ChatPromoBanner";

const { Title, Text } = Typography;

function Category({analytics}){
    const {id} = useParams()
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [tagData,setTagData] = useState({})
    const [QN,setQN] = useState(0);
    const [loading,setLoading] = useState(true);
    const [value,setValue] = useState(null);
    const [answered,setAnswered] = useState(false);
    const dispatch = useDispatch();

    useEffect(()=>{
        analytics()
        api.API.get(`/api/tags/${id}`).then(tagData=>{
            setTagData(tagData)
            setLoading(false)
        })
    }, [id])

    let currentQuestion = tagData?.questions ? tagData?.questions[QN] : null
    let totalQuestions = tagData?.questions?.length || 0;

    const handleSubmit = (variant) =>{
        if(currentQuestion.answer !== variant){
            dispatch({
                payload:[currentQuestion.id],
                type:'QUESTIONS_PASSED'
            })
        } else {
            dispatch({
                payload:currentQuestion.id,
                type:'QESTION_PASSED'
            })
        }
        setValue(variant)
        setAnswered(true)
    }

    const handleNext = ()=>{
        setAnswered(false)
        setValue(null)
        setQN(QN + 1)
    }

    if (loading) return <div style={{ textAlign: 'center', padding: '50px' }}><Spin size="large" /></div>

    return (
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
            <Helmet>
                <title>{tagData.name ? `${tagData.name} - ${t('header.grouped_questions')}` : t('seo.categories_title')}</title>
                <meta name="description" content={`${t('seo.categories_desc')} - ${tagData.name}`} />
            </Helmet>



            <Card size="small" style={{ marginBottom: 20, borderRadius: 12, borderLeft: '6px solid #1890ff' }}>
                <Row justify="space-between" align="middle">
                    <Col>
                        <Space>
                            <Button icon={<UnorderedListOutlined />} onClick={() => navigate('/categories')} />
                            <Title level={4} style={{ margin: 0 }}>{tagData.name}</Title>
                        </Space>
                    </Col>
                    <Col style={{ textAlign: 'right' }}>
                        <Text strong>{QN + 1} / {totalQuestions}</Text>
                    </Col>
                </Row>
                <Progress 
                    percent={Math.round(((QN + 1) / totalQuestions) * 100)} 
                    size="small" 
                    status="active"
                    strokeColor="#1890ff"
                />
            </Card>

            <Spin spinning={loading}>
                {currentQuestion ? (
                    <div>
                        <QuestionItem 
                            quick_view={true} 
                            currentQuestion={currentQuestion} 
                            handleNext={handleSubmit} 
                            noSubmit={answered !== false} 
                            value={value}
                        />
                        
                        {answered !== false && QN < totalQuestions - 1 && (
                            <div style={{ textAlign: 'center', marginTop: 30 }}>
                                <Button 
                                    size="large" 
                                    type="primary" 
                                    icon={<ArrowRightOutlined />} 
                                    onClick={handleNext}
                                    style={{ minWidth: 200, borderRadius: 8 }}
                                >
                                    {t('questions.next')}
                                </Button>
                            </div>
                        )}

                        {QN === totalQuestions - 1 && answered !== false && (
                            <div style={{ textAlign: 'center', marginTop: 30 }}>
                                <Button 
                                    size="large" 
                                    type="primary" 
                                    onClick={() => navigate('/categories')}
                                    style={{ borderRadius: 8 }}
                                >
                                    {t('questions.back_to_list')}
                                </Button>
                            </div>
                        )}
                    </div>
                ) : (
                    <Empty description="Հարցեր չեն գտնվել" />
                )}
            </Spin>
        </div>
    )
}
export default Category;
